import * as React from "react";
import { Box, styled, SxProps } from "@mui/material";
import Cover from "../Cover";
import { hexToRgbString } from "../../../Utils/Helpers/cssUtils";

export type HeroProps = {
  sx?: SxProps;
  src: string;
};

const Hero: React.FC<HeroProps> = (props) => {
  const { src, sx } = props;

  return (
    <StyledHero sx={{ ...sx }}>
      <Cover img={{ src }} />
    </StyledHero>
  );
};

export default Hero;

const StyledHero = styled(Box)(({ theme }) => ({
  position: "absolute",
  height: "400px",
  overflow: "hidden",
  left: 0,
  right: 0,
  zIndex: 0,

  "&:after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      //   theme.palette.mode === "dark"
      //     ?
      `linear-gradient(180deg, rgba(${hexToRgbString(theme.palette.background.default)}, 0) 0%, rgba(${hexToRgbString(
        theme.palette.background.default
      )}, 0.79) 55.61%, ${theme.palette.background.default} 100%), linear-gradient(166deg, rgba(${hexToRgbString(
        theme.palette.background.default
      )}, 0.70) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0.00) 100%)`,
    // : `radial-gradient(60% 120% at -0.00% 0%, rgba(${hexToRgbString(
    //     theme.palette.background.default
    //   )}, .8) 0%, rgba(${hexToRgbString(theme.palette.background.default)}, 0) 70%)`,
  },
}));
